import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";
// import defaultState from "./modules/default";


Vue.use(Vuex);

import createPersistedState from 'vuex-persistedstate'

export default new Vuex.Store({
  plugins:[createPersistedState()],
  state: {
    departments: [],
    progress: {
      total: {
        type: Number
      },
      current: {
        type: Number,
        default: 1
      }
    },
    authenticated:false,
    master_user:false,
    user_data:{},
    //armazena formulario de todas modais de forma temporaria 
    temp_data: {},
    company_select:"",
    departament_select:"",
    temp_labels:{},
    notification_list:[],
    hasNotifications: false,
    company_list:[],
    id_totem_company_select:[],
    total_company_select:0,
    id_usuario_edit:"",

  },
  mutations,
  actions,
  getters
});
